import { useEffect, useState } from 'react';

const ZXCVBN_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/zxcvbn/4.4.2/zxcvbn.js';

let loadPromise = null;

function loadZxcvbn() {
    if (window.zxcvbn) {
        return Promise.resolve();
    }
    if (!loadPromise) {
        loadPromise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = ZXCVBN_SRC;
            script.async = true;
            script.onload = () => resolve();
            script.onerror = () => reject(new Error('zxcvbn load failed'));
            document.body.appendChild(script);
        });
    }
    return loadPromise;
}

export default function useZxcvbn() {
    const [ready, setReady] = useState(!!window.zxcvbn);
    const [failed, setFailed] = useState(false);
    useEffect(() => {
        if (window.zxcvbn) {
            setReady(true);
            return undefined;
        }
        let cancelled = false;
        loadZxcvbn()
            .then(() => {
                if (!cancelled) {
                    setReady(true);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setFailed(true);
                }
            });
        return () => {
            cancelled = true;
        };
    }, []);
    const score = password =>
        (ready && password && typeof window.zxcvbn === 'function' ? window.zxcvbn(password).score : null);
    return { ready, failed, score };
}

export function __resetLoadStateForTests() {
    loadPromise = null;
}
